export const redirectToAuthorise = (redirectUri: string) => {
  const nonce = window.crypto.randomUUID();
  // SameSite=Lax, not Strict: with nav on app.accesso.ai and aiakos on dexibit.com,
  // the OIDC callback arrives as a cross-site-initiated top-level navigation, and a
  // Strict cookie is withheld from it — the BFF then never sees the original path.
  // Lax is safe here: the cookie is nonce-named and holds only a path, not a
  // credential, and Lax still withholds it from cross-site POSTs.
  document.cookie = `${nonce}=${window.location.pathname}${window.location.search}; path=/; secure; sameSite=lax; max-age=3600`;
  window.location.href = `${redirectUri}&state=${nonce}`;
};
